import axios from "axios";

export default {
  namespaced: true,
  state: {
    // mySchedules 관련 데이터
    total: 0,
    mySchedules: [],
    /**
     * occupied
     *
     * Chatter Status Board가 이미 Chatter List를 사용하고 있음을 나타내는 플래그.
     * Chatter List 리로드 시 filter를 무시하도록 구현되어 있음.
     * TODO 추후 기능 개선 필요
     * @author Jiwon Yoon 2023-08-17
     */
    occupied: false,
    notifications: [],
    filter: {
      myScheduleId:"",
      status: "",
      assignee: "",
      keyword: "",
      keywordWithComment: false,
      query: "",
      updated: "",
      sort: [],
      page: 1,
      pageSize: 10,
    },
    options: {
      statusOptions: [
        {
          value: "TO_DO",
          text: "\u00A0\u00A0To Do",
          disabled: false,
          update: true,
        },
        {
          value: "IN_PROGRESS",
          text: "\u00A0\u00A0In Progress",
          disabled: false,
          update: true,
        },
        {
          value: "DONE",
          text: "\u00A0\u00A0Done",
          disabled: false,
          update: true,
        },
        {
          value: "CANCELLED",
          text: "\u00A0\u00A0Cancelled",
          disabled: false,
          update: true,
        },
      ],
      priorityOptions: ["", 'High', 'Medium', 'Low'],
      assigneeOptions: [],
      //projectOptions: [],
      levelOptions: [
        { value: "", text: "" },
        { value: "3", text: "Critical" },
        { value: "2", text: "Major" },
        { value: "1", text: "Minor" },
        { value: "0", text: "Trivial" },
      ],

      fieldOptions: [
        { value: "", text: "--choose field--", disabled: true },
        { value: "Project", text: "Project", type: "var" },
        { value: "Status", text: "Status", type: "var" },
        { value: "Assignee", text: "Assignee", type: "var" },
      ],

    }
  },
  getters: {
    mySchedules(state) {
      return state.mySchedules;
    },
    total(state) {
      return state.total;
    },
    occupied(state) {
      return state.occupied;
    },
    filter(state) {
      return state.filter;
    },
    options(state) {
      return state.options;
    },
    statusOptions(state) {
      return state.options.statusOptions;
    },
    assigneeOptions(state) {
      return state.options.assigneeOptions;
    },
    /*
    projectOptions(state) {
      return state.options.projectOptions;
    },*/
    priorityOptions(state) {
      return state.options.priorityOptions;
    },
    levelOptions(state) {
      return state.options.levelOptions;
    },
    typeOptions(state) {
      return state.options.typeOptions;
    },
    fieldOptions(state) {
      return state.options.fieldOptions;
    },
    operatorOptions(state) {
      return state.options.operatorOptions;
    },
    valueOptions(state) {
      return state.options.valueOptions;
    },
    jobOptions(state) {
      return state.options.jobOptions;
    },
    projectStatusOptions(state) {
      return state.options.projectStatusOptions;
    },
    getProjectList(state) {
      return state.projectList;
    },
    getNotifications(state) {
      return state.notifications;
    },
    getNotificationCount(state) {
      return state.notifications.length;
    },
    getAllProjectInfo(state) {
      return state.allProjectInfo;
    },
    getUpdated(state) {
      return state.filter.updated;
    }
  },
  actions: {
  },
  mutations: {
    setMySchedules(state, mySchedules) {
      state.mySchedules = mySchedules;
    },
    setTotal(state, total) {
      state.total = total;
    },
    incrementPage(state) {
      state.filter.page += 1;
    },
    setPage(state, page) {
      state.filter.page = page;
    },
    setOccupied(state, occupied) {
      state.occupied = occupied;
    },
    setProjectList(state, data) {
      state.projectList = data;
    },
    /*
    setProjectOptions(state, data) {
      data.forEach(object => {
        object.text = object.name;
        object.value = object.projectId;
      });
      state.options.projectOptions = data.sort((a, b) => {
        return a.text.localeCompare(b.text);
      });
    }, */
    setAssigneeOptions(state, data) {
      data.forEach(object => {
        object.value = object.userId;
        object.text = object.userName;
      });
      state.options.assigneeOptions = data.sort((a, b) => {
        return a.text.localeCompare(b.text);
      });
    },
    setNotifications(state, data) {
      state.notifications = data;
    },
    setAllProjectInfo(state, data) {
      state.allProjectInfo = data;
    },
    setAllProjectRoles(state, data) {
      state.allProjectRoles = data;
    },
    setUpdated(state, data) {
      state.filter.updated = data;
    },
    setQuery(state, data) {
      state.filter.query = data;
    },
    setSort(state, columns) {
      state.filter.sort = columns
          .filter(col => col.sort)
          .map(col => ({
            colName: col.colName,
            sort: col.sort
          }))
    },
    resetFilter(state) {
      state.filter = {
        status: "",
        assignee: "",
        keyword: "",
        keywordWithComment: false,
        query: "",
        updated: "",
        sort: [],
        page: 1,
        pageSize: 10,
      };
    }
  },
};